import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.scss';

const RequiredAsterisk = ({ className }) => <span className={classNames(className, styles.root)}>*</span>;

RequiredAsterisk.propTypes = {
  className: PropTypes.string,
};

export default RequiredAsterisk;



// WEBPACK FOOTER //
// src/components/shared/RequiredAsterisk/index.jsx